import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';
import type { ApiAppUser } from './api.types';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  listAppUsers(): Promise<{ items: ApiAppUser[] }> {
    return this.api.get<{ items: ApiAppUser[] }>('/users/admin');
  }
}